"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.AsyncSelect = exports.Select = void 0;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_select_1 = __importStar(require("react-select"));
var async_1 = __importDefault(require("react-select/async"));
var draft_form_1 = require("@kaizen/draft-form");
var component_library_1 = require("@kaizen/component-library");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var clear_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/clear.icon.svg"));
var draft_tag_1 = require("@kaizen/draft-tag");
var styles_react_scss_1 = __importDefault(require("./styles.react.scss"));
exports.Select = React.forwardRef(function (props, ref) {
    var _a;
    if (props.fullWidth === false && props.variant !== "secondary") {
        throw new Error('the prop fullWidth=false is not yet implemented when variant="default"');
    }
    var _b = props.variant, variant = _b === void 0 ? "default" : _b, _c = props.status, status = _c === void 0 ? "default" : _c, _d = props.reversed, reversed = _d === void 0 ? false : _d, label = props.label, validationMessage = props.validationMessage, description = props.description;
    // the default for fullWidth depends on the variant
    var fullWidth = props.fullWidth != null
        ? props.fullWidth
        : variant === "secondary" || variant === "secondary-small"
            ? false
            : true;
    if (reversed === true && variant === "default") {
        throw new Error('the combo variant="default" and reversed=true is not yet implemented for the Select component');
    }
    var classes = (0, classnames_1["default"])(props.className, styles_react_scss_1["default"].specificityIncreaser, (_a = {},
        _a[styles_react_scss_1["default"]["default"]] = !reversed,
        _a[styles_react_scss_1["default"].reversed] = reversed,
        _a[styles_react_scss_1["default"].secondary] = variant === "secondary",
        _a[styles_react_scss_1["default"].secondarySmall] = variant === "secondary-small",
        _a[styles_react_scss_1["default"].notFullWidth] = !fullWidth,
        _a[styles_react_scss_1["default"].disabled] = props.isDisabled,
        _a[styles_react_scss_1["default"].error] = status === "error",
        _a));
    return (React.createElement(React.Fragment, null,
        label ? React.createElement(draft_form_1.Label, null, label) : null,
        React.createElement(react_select_1["default"], __assign({}, props, { ref: ref, components: {
                Control: Control,
                Placeholder: Placeholder,
                DropdownIndicator: DropdownIndicator,
                Menu: Menu,
                Option: Option,
                NoOptionsMessage: NoOptionsMessage,
                SingleValue: SingleValue,
                MultiValue: MultiValue,
                IndicatorsContainer: IndicatorsContainer,
                ValueContainer: ValueContainer,
                ClearIndicator: ClearIndicator,
                IndicatorSeparator: null
            }, className: classes })),
        validationMessage ? (React.createElement(draft_form_1.FieldMessage, { message: validationMessage, status: status })) : null,
        description ? React.createElement(draft_form_1.FieldMessage, { message: description }) : null));
});
exports.Select.displayName = "Select";
exports.AsyncSelect = React.forwardRef(function (props, ref) { return (React.createElement(async_1["default"], __assign({}, props, { ref: ref, components: {
        Control: Control,
        Placeholder: Placeholder,
        DropdownIndicator: DropdownIndicator,
        Menu: Menu,
        Option: Option,
        NoOptionsMessage: NoOptionsMessage,
        SingleValue: SingleValue,
        MultiValue: MultiValue,
        IndicatorsContainer: IndicatorsContainer,
        ValueContainer: ValueContainer,
        ClearIndicator: null,
        IndicatorSeparator: null,
        LoadingMessage: LoadingMessage
    }, className: (0, classnames_1["default"])(styles_react_scss_1["default"].specificityIncreaser, props.className) }))); });
exports.AsyncSelect.displayName = "AsyncSelect";
var Control = function (props) {
    var _a;
    return (React.createElement("div", { "data-automation-id": "Select__Control" },
        React.createElement(react_select_1.components.Control, __assign({}, props, { className: (0, classnames_1["default"])(styles_react_scss_1["default"].control, (_a = {},
                _a[styles_react_scss_1["default"].focusedControl] = props.isFocused,
                _a[styles_react_scss_1["default"].disabled] = props.isDisabled,
                _a)) }))));
};
var Placeholder = function (props) { return (React.createElement(react_select_1.components.Placeholder, __assign({}, props),
    React.createElement("span", { className: styles_react_scss_1["default"].placeholder }, props.children))); };
var DropdownIndicator = function (props) { return (
// Suppress typing issue - looks like the type defs are incorrect
// @ts-ignore
React.createElement(react_select_1.components.DropdownIndicator, __assign({}, props, { className: styles_react_scss_1["default"].dropdownIndicator }),
    React.createElement(component_library_1.Icon, { icon: chevron_down_icon_svg_1["default"], role: "presentation" }))); };
var LoadingMessage = function (props) { return (React.createElement(react_select_1.components.LoadingMessage, __assign({}, props, { className: styles_react_scss_1["default"].loadingMessage }))); };
var Menu = function (props) { return (React.createElement(react_select_1.components.Menu, __assign({}, props, { className: styles_react_scss_1["default"].menu }))); };
var Option = function (props) {
    var _a;
    return (React.createElement("div", { "data-automation-id": "Select__Option" },
        React.createElement(react_select_1.components.Option, __assign({}, props, { className: (0, classnames_1["default"])(styles_react_scss_1["default"].option, (_a = {},
                _a[styles_react_scss_1["default"].focusedOption] = props.isFocused,
                _a[styles_react_scss_1["default"].selectedOption] = props.isSelected,
                _a[styles_react_scss_1["default"].disabledOption] = props.isDisabled,
                _a)) }))));
};
var NoOptionsMessage = function (props) { return (React.createElement(react_select_1.components.NoOptionsMessage, __assign({}, props),
    React.createElement("span", { className: styles_react_scss_1["default"].noOptionsMessage }, props.children))); };
var SingleValue = function (props) { return (React.createElement(react_select_1.components.SingleValue, __assign({}, props, { className: styles_react_scss_1["default"].singleValueOverrides }),
    React.createElement("span", { className: styles_react_scss_1["default"].singleValue }, props.children))); };
var MultiValue = function (props) { return (React.createElement("div", { className: styles_react_scss_1["default"].multiValue },
    React.createElement(draft_tag_1.Tag, { children: props.children, variant: "default", dismissible: true, inline: true, onDismiss: props.removeProps.onClick }))); };
var IndicatorsContainer = function (props) { return (React.createElement(react_select_1.components.IndicatorsContainer, __assign({}, props, { className: styles_react_scss_1["default"].indicatorsContainer }))); };
var ValueContainer = function (props) { return (React.createElement(react_select_1.components.ValueContainer, __assign({}, props, { className: styles_react_scss_1["default"].valueContainer }))); };
var ClearIndicator = function (props) { return (React.createElement(react_select_1.components.ClearIndicator, __assign({}, props),
    React.createElement(component_library_1.Icon, { icon: clear_icon_svg_1["default"], role: "presentation" }))); };
//# sourceMappingURL=Select.js.map